import Avo from 'analytics/Avo';
import React, { useEffect } from 'react';
import { screenEvent } from 'utils/careem/create-careem-screen';
import { trackEvent } from 'wrappers/reporting';

interface PageViewAnalyticsProps {
  pageName: string;
  previousScreen?: string;
}

const withPageViewAnalytics =
  <P extends object>(pageViewAnalyticsProps: PageViewAnalyticsProps) =>
  (WrappedComponent: React.ComponentType<P>) => {
    const { pageName, previousScreen } = pageViewAnalyticsProps;
    const WithPageViewAnalytics: React.FC<P> = (props) => {
      useEffect(() => {
        screenEvent(pageName);
        trackEvent(`Viewed ${pageName} Page`);
        Avo.pageview({
          screen: pageName,
          previousScreen,
        });
      }, []);

      return <WrappedComponent {...props} />;
    };

    return WithPageViewAnalytics;
  };

export default withPageViewAnalytics;
